import { CONTACT_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const maincontactsSlice = createResourceSlice({
    resource: CONTACT_RESOURCE,
    byKey: 'customerId',
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexContacts,
    showContact,
    storeContact,
    updateContact,
    archiveContact,
    restoreContact,
    destroyContact,
} = maincontactsSlice.actions;

export const {
    selectContactById,
    makeContactsByIdsSelector,
    selectAllContactIds,
    selectAllContacts,
    selectContactsLoading,
    selectContactsInitialized,
    selectContactLoading,
    selectContactInitialized,
    selectContactIdsByCustomerId,
    makeContactsByCustomerIdSelector,
    selectContactLoadingByCustomerId,
    selectContactInitializedByCustomerId,
} = maincontactsSlice.selectors;

export const { useMainContacts, useMainContact, useMainContactsByCustomerId } =
    maincontactsSlice.hooks;

export default maincontactsSlice.reducer;
